// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__31hSe","loaderOuter":"PageOverlayLoader_loaderOuter__dE1WF"};